function handleClickAndPress(myfunc){
    return function (e) {
        if (e.type != 'keypress' || e.keyCode == 13) {
            myfunc(e)
        }
    };
}

$.fn.focusAnchor = function() {
	//
	// DEPRECATED
	// USE link-internal.js instead
	//

    return this.each(function(){
        $(this).on("click", function (e) {
            e.preventDefault();
            var myAnchor = jQuery(this).attr('href');
            jQuery(myAnchor).attr('tabindex', '0');
            jQuery(myAnchor).focus();
            return false;
        });
    });
}

jQuery(document).ready(function () {
    'use strict';

	//
	// DEPRECATED
	// USE link-internal.js instead
	//
	
    // en ajoutant cette class .focusOnMyAnchor aux ancres,
    // cela ferra un focus bulletproof pour l'accessibilité
    jQuery('.focusOnMyAnchor').focusAnchor();

    focusOnMySelect();

    jQuery(function () {
        jQuery('.focus').attr('tabindex', '0').focus();
    });

});


function focusOnMySelect() {
    jQuery('.focusOnMySelect').on("click", function (e) {
        var product = $(this).closest('.item-addToCart');
        var selector = product.find('.select-addToCart');
        jQuery(selector).focus();
        e.preventDefault();
    });
}

function externalLinkAssist() {
    let linkText = document.documentElement.lang === 'en-CA' ? 'This link opens a new window.' : 'Ce lien ouvre une nouvelle fenêtre.';

    const extLinkAssist = document.querySelectorAll('.external--link');
    $(extLinkAssist).each(function() {
        if ($(this).children('.external--link--text').length === 0) {
            $(this).append('<span class="invisible-text external--link--text">' + linkText + '</span>');
        }
    });
}
